export default __webpack_public_path__ + "static/media/renewables.5da78a19.jpg";